import {AttachmentFile} from "ts/api/attachmentFile";
import FlexRow from "view/components/Layout/FlexRow";
import FlexBox from "view/components/Layout/FlexBox";
import React from "react";
import {makeStyles, Typography} from "@material-ui/core";
import {T} from "@tolgee/react";
import Attachment from "view/components/TaskCommentsSection/Comment/Attachment/CommentAttachment";

const useStyles = makeStyles(({spacing, palette}) => ({
  text: {
    fontSize: `${spacing(1.5)}px !important`,
    color: palette.contrastText.main,
    textTransform: "uppercase",
    letterSpacing: `${spacing(0.25)}px !important`,
    fontWeight: 500,
  },
}));

type Props = {
  attachment: AttachmentFile;
  /** Section label; defaults to "TASK PRINT VERSION". */
  title?: string;
};

const PrintedTaskAttachment = ({attachment, title}: Props) => {
  const classes = useStyles();

  return (
    <FlexBox column gap={2}>
      <FlexRow justifyContent="space-between" alignItems="center">
        <Typography className={classes.text}>
          {title ?? <T keyName="common.tasks.print_version_title" />}
        </Typography>
      </FlexRow>
      <Attachment attachment={attachment} allowCopyLink />
    </FlexBox>
  );
};
export default PrintedTaskAttachment;
